/** HTTP wire values shared by conditional reads and polling error handling. */
export const HTTP_METHOD = { get: "GET" } as const;
export const HTTP_HEADER = {
  authorization: "Authorization",
  ifNoneMatch: "If-None-Match",
  etag: "ETag",
  contentType: "Content-Type",
  retryAfter: "Retry-After",
} as const;
export const HTTP_STATUS = {
  ok: 200,
  successUpperBound: 300,
  notModified: 304,
  badRequest: 400,
  unauthorized: 401,
  forbidden: 403,
  notFound: 404,
  payloadTooLarge: 413,
  unprocessableEntity: 422,
  tooManyRequests: 429,
  serviceUnavailable: 503,
} as const;
export const HTTP_CACHE_MODE = { noStore: "no-store" } as const;
export const MEDIA_TYPE = { json: "application/json" } as const;
export const ABORT_ERROR_NAME = "AbortError";
